// src/helpers/dateUtils.js

/**
 * Formatea una cadena de fecha a formato ISO (YYYY-MM-DD).
 * @param {string} dateString - La cadena de fecha.
 * @returns {string} - La fecha formateada o una cadena vacía si es inválida.
 */
export const formatDate = (dateString) => {
    if (!dateString) return ""; // Retorna una cadena vacía si no hay valor
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ""; // Retorna una cadena vacía si la fecha es inválida
    return date.toISOString().split("T")[0];
  };
  
  /**
   * Convierte una fecha en formato ISO (YYYY-MM-DD) a un objeto Date.
   * @param {string} isoString - La cadena de fecha en formato ISO.
   * @returns {Date|null} - Un objeto Date o null si la fecha es inválida.
   */
  export const parseDateFromISO = (isoString) => {
    const date = new Date(isoString);
    return isNaN(date.getTime()) ? null : date;
  };
  

  export const formatDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2); // 👈 solo 2 dígitos

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};